import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countDownColorClass'
})
export class CountDownColorClassPipe implements PipeTransform {
  transform(time: number): 'five-minutes' | 'one-minute' | 'ten-seconds' {
    if (time > 60 || time == null) {
      return 'five-minutes';
    } else if (time <= 60 && time > 10) {
      return 'one-minute';
    } else {
      return 'ten-seconds';
    }
  }
}
